<template>
  <Documentation class="doc-page" />
</template>

<script>
import Documentation from "@/components/Documentation.vue";

export default {
  components: {
    Documentation
  }
};
</script>
